module.exports = "#version 100\nprecision highp float;\n\nattribute vec3 a_position;\n\nvarying vec2 v_uv;\n\nvoid main() {\n    gl_Position = vec4(a_position, 1.0);\n    v_uv = a_position.xy * 0.5 + 0.5;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/quad.vert.glsl
// module id = 13
// module chunks = 0